import { Component } from '@angular/core';

@Component({
  selector: 'tln-javelo-logo',
  templateUrl: './javelo-logo.component.html',
  styleUrls: ['./javelo-logo.component.less'],
  standalone: true,
})
export class JaveloLogoComponent {}
